import { useFragment } from "react-relay"
import { useAppointmentParam } from "@/modules/patients/hooks/useAppointmentParam"
import { useCountryParam } from "@/modules/patients/hooks/useCountryParam"
import { usePatientParam } from "@/modules/patients/hooks/usePatientParam"
import { PatientContextAppointmentFragment$key } from "@/modules/patients/services/__generated__/PatientContextAppointmentFragment.graphql"
import { PatientContextAppointmentFragment } from "@/modules/patients/services/PatientContextAppointmentFragment"
import { usePatientByIdQuery } from "@/modules/patients/services/usePatientByIdQuery"
import { getDistinctPhoneNumbers } from "@/modules/telephony/lib/get-distinct-phone-numbers"
import useCallContextStore from "@/stores/useCallContextStore"

const usePatientPhoneNumbersOnCall = () => {
  const inboundCallerPhoneNumber = useCallContextStore((state) => state.callerPhoneNumber)
  const patientId = usePatientParam()
  const countryCode = useCountryParam()
  const appointmentId = useAppointmentParam()
  const [patientData] = usePatientByIdQuery(patientId, countryCode, appointmentId)
  const contextAppointment = useFragment<PatientContextAppointmentFragment$key>(
    PatientContextAppointmentFragment,
    appointmentId ? patientData.patientById?.contextAppointment : null,
  )

  return getDistinctPhoneNumbers([
    inboundCallerPhoneNumber,
    contextAppointment?.patientPhoneNumber,
    patientData.patientById?.phoneNumber,
  ])
}

export { usePatientPhoneNumbersOnCall }
